export enum OAuthProvider {
  google = 'google',
  facebook = 'facebook',
  soundCloud = 'soundcloud',
}
